import React from 'react';
import withPageComponents from '../../page/components/with-page-components';

const leftRailBanner = ({ vwaLeftnavBanner }) => {
    if (!vwaLeftnavBanner || !vwaLeftnavBanner[0]) return null;

    // TODO: stellar working on banner + new banner props are different so espot breaks
    // return <SlimBanner className="leftRailBanner" {...vwaLeftnavBanner[0]} useMobileStyles={true} />;
    return null;
};

export default withPageComponents(leftRailBanner, { components: ['vwaLeftnavBanner'] });
